export default function getVerticalShift(verticalAlign, option) {
    const { index = 1, align = 'stack' } = option || {
        index: 1,
        align: 'stack',
    };
    return verticalAlign.align === align
        ? index * verticalAlign.verticalShift
        : 0;
}
